// IMPORT
const THREE = require('three')
import Vehicle from './vehicle'
import {loadingManager, load, registerSize} from '../loader'
import {TimelineMax, TweenMax, Cubic, Expo, CustomEase} from 'gsap'
import lerp from 'lerp'
import {state as gameState} from '../main'
import {config as gameConfig} from '../config'

// ****************************************************************
//
// PARTS
//
// ****************************************************************
let base = require('src/../config').build.assetsPublicPath
const parts = [
  {
    model: {
      url: require('assets/models/bike/bike_chassis.json'),
      size: 159115
    },
    texture: {
      url: require('assets/models/bike/bike_chassis.png'),
      size: 55807
    },
    scale: 0.048
  },
  {
    model: {
      url: require('assets/models/bike/bike_wheels.json'),
      size: 108905
    },
    texture: {
      url: require('assets/models/bike/bike_wheels.png'),
      size: 61499
    },
    scale: 0.048
  },
  {
    model: {
      url: require('assets/models/bike/bike_rider.json'),
      size: 137483
    },
    texture: {
      url: require('assets/models/bike/bike_rider.png'),
      size: 52155
    },
    scale: 0.048
  }
]


// ****************************************************************
//
// SOUNDS
//
// ****************************************************************
const sounds = {
  bike: {
    url: require('src/assets/sounds/fx/vehicles/bike3.mp3'),
    size: 58005,
    distance: 60
  }
}



// ****************************************************************
//
// CLASS
//
// ****************************************************************
class Bike extends Vehicle {

  constructor (config) {
    super(Object.assign(config, {parts: parts, sounds: sounds, type: 'bike'}))
    this.model = new THREE.Object3D()
    this.mesh.add(this.model)
    // this.init()
    this.model.rotation.y = THREE.Math.DEG2RAD * 180
  }

  // **********************************************************************
  //
  // METHODS
  //
  // **********************************************************************
  start = ()=> {
    // this.audio.bike.play()
    for (let part of this.model.children) {
      part.position.z = -1.6
    }
    this.model.position.z = 1.6
  }

  playAnim = (time = 1)=> {
    this.toUserFront(time, -0.015, 0.007)

    let rotStart = new THREE.Vector3(0, THREE.Math.DEG2RAD * 180, 0)
    let posStart = this.model.position

    this.model.rotation.set(rotStart.x, rotStart.y, rotStart.z)
    TweenMax.to(this.model.rotation, time, {
      // y: rotStart.y + THREE.Math.DEG2RAD * 30,
      x: rotStart.x + THREE.Math.DEG2RAD * -50,
      // z: rotStart.z + THREE.Math.DEG2RAD * -25,
      ease: Cubic.easeIn
      // ease: CustomEase.create('custom', 'M0,0,C0,0,0.54,-0.065,0.57,0.2,0.578,0.274,0.674,0.978,0.786,1,0.92,0.934,1,0,1,0')
    })
  }



}


export default Bike


// WEBPACK FOOTER //
// ./src/components/game/runner/bike.js